import { createSlice } from "@reduxjs/toolkit"

export const productSlice = createSlice({
  name: "calenderProducts",
  initialState: {
    productList: [],
    brandList: [],
    categoryList: [],
    exportList: [],
    productDetail: {},
    isFreshData: false,
    totalEntry: 0,
    filterTerm: ''
  },
  reducers: {
    setProductList: (state, action) => {
      state.productList = action.payload
    },
    setBrandList: (state, action) => {
      state.brandList = action.payload
    },
    setCategoryList: (state, action) => {
      state.categoryList = action.payload
    },
    setExportList: (state, action) => {
      state.exportList = action.payload
    },
    setFilterTerm: (state, action) => {
      state.filterTerm = action.payload
    },
    setTotalEntry: (state, action) => {
      state.totalEntry = action.payload
    },
    setSingleData: (state, action) => {
      state.productDetail = action.payload
    }
  }
})

export const {
  setProductList,
  setBrandList,
  setCategoryList,
  setExportList,
  setFilterTerm,
  setSingleData,
  setTotalEntry,
  setFilteredList
} = productSlice.actions

export const selectProductList = (state) => state.calenderProduct.productList
export const selectBrandList = (state) => state.calenderProduct.brandList
export const selectCategoryList = (state) => state.calenderProduct.categoryList
export const selectExportList = (state) => state.calenderProduct.exportList
export const selectFilterTerm = (state) => state.calenderProduct.filterTerm
export const selectTotalEntry = (state) => state.calenderProduct.totalEntry
export const selectProductDetail = (state) => state.calenderProduct.productDetail

export default productSlice.reducer
